// Base 5 diagnostic questions (12 questions across 5 spheres)
const base5 = [
    // ── I Sfera: Bendroji energija ir savimoka — 3 questions ──
    {
      id: 'q1',
      sphere: 'bendra',
      question: 'Kai gyvenime atsiranda netikėtas pokytis ar nauja kryptis:',
      choices: {
        a: 'Priimu jį su smalsumu ir entuziazmu – pokyčiai mane gaivina ir įkvepia.',
        b: 'Puolu į kraštutinumą – arba viską metu ir bėgu, arba paniškai vengiu bet kokio pokyčio.',
        c: 'Iš pradžių pasveriu, ar pokytis vertas rizikos, ir tik tada apsisprendžiu.',
      },
    },
    {
      id: 'q2',
      sphere: 'bendra',
      question: 'Kai turiu daug laisvės ir galiu pats spręsti, kaip leisti savo laiką:',
      choices: {
        a: 'Tai man labai svarbu – laisvė įkvepia mane kurti ir veikti atsakingai.',
        b: 'Greitai pasimetu, blaškausi tarp daugybės dalykų ir nebaigiu pradėtų darbų.',
        c: 'Mėgaujuosi laisve, bet stengiuosi susidėlioti bent minimalią dienos tvarką.',
      },
    },
    {
      id: 'q3',
      sphere: 'bendra',
      question: 'Kai kažkas bando mane suvaržyti taisyklėmis ar griežtais rėmais:',
      choices: {
        a: 'Ramiai randu būdą išlikti laisvas, bet nepažeisdamas kitų ribų.',
        b: 'Iškart maištauju arba slapčia darau savaip, net jei tai pakenkia man pačiam.',
        c: 'Prisitaikau prie būtinų taisyklių, bet pasilieku sau erdvės manevrui.',
      },
    },
    // ── II Sfera: Darbas ir karjera — 2 questions ──
    {
      id: 'q4',
      sphere: 'karjera',
      question: 'Kai darbas tampa monotoniškas ir kasdien tas pats:',
      choices: {
        a: 'Randu būdą jį paįvairinti arba imuosi naujų iššūkių, kurie mane vėl uždega.',
        b: 'Greitai prarandu motyvaciją, pradedu vėluoti arba svajoju viską mesti.',
        c: 'Atlieku, ką privalau, bet sąmoningai ieškau naujovių, kai tik atsiranda proga.',
      },
    },
    {
      id: 'q5',
      sphere: 'karjera',
      question: 'Kai reikia rinktis tarp stabilaus, bet nuobodaus darbo ir įdomaus, bet rizikingo:',
      choices: {
        a: 'Renkuosi tai, kas įdomu ir vysto mane, bet apgalvoju, kaip suvaldyti riziką.',
        b: 'Blaškausi, dažnai keičiu darbus arba šoku į riziką neapgalvojęs pasekmių.',
        c: 'Sveriu abu variantus ir renkuosi protingą vidurio kelią tarp saugumo ir įdomumo.',
      },
    },
    // ── III Sfera: Santykiai ir partnerystė — 2 questions ──
    {
      id: 'q6',
      sphere: 'santykiai',
      question: 'Kai santykiuose pajuntu įsipareigojimo ir kasdienybės svorį:',
      choices: {
        a: 'Ieškau būdų išlaikyti gaivumą ir bendrus nuotykius, neprarasdamas artumo.',
        b: 'Pradedu dusti, ieškoti dingsčių pabėgti arba blaškausi tarp kelių žmonių.',
        c: 'Stengiuosi rasti pusiausvyrą tarp asmeninės laisvės ir bendro pastovumo.',
      },
    },
    {
      id: 'q7',
      sphere: 'santykiai',
      question: 'Kai galvoju apie tai, kas mane traukia artimame žmoguje:',
      choices: {
        a: 'Vertinu lengvumą, atvirumą naujovėms ir gebėjimą kartu patirti nuotykius.',
        b: 'Greitai prarandu susidomėjimą arba bijau įsipareigoti, todėl laikausi atstumo.',
        c: 'Ieškau žmogaus, su kuriuo derėtų ir laisvė, ir saugus artumas.',
      },
    },
    // ── IV Sfera: Finansai ir resursai — 2 questions ──
    {
      id: 'q8',
      sphere: 'finansai',
      question: 'Kai į rankas patenka pinigų ar laisvų resursų:',
      choices: {
        a: 'Mėgaujuosi galimybe, bet protingai juos paskirstau patirtims ir ateičiai.',
        b: 'Greitai išleidžiu impulsyviai ar malonumams, o paskui pritrūksta būtiniausiam.',
        c: 'Dalį skiriu malonumams, dalį atidedu – stengiuosi laikytis saiko.',
      },
    },
    {
      id: 'q9',
      sphere: 'finansai',
      question: 'Kai galvoju apie pinigų uždirbimą:',
      choices: {
        a: 'Pasitikiu savo gebėjimu prisitaikyti ir rasti naujų, įvairių pajamų šaltinių.',
        b: 'Pajamos chaotiškai svyruoja, nes greitai pavargstu arba metu pradėtus dalykus.',
        c: 'Stengiuosi turėti pagrindinį pajamų šaltinį, o naujas galimybes išbandau atsargiai.',
      },
    },
    // ── V Sfera: Savirealizacija ir gyvenimo situacija — 3 questions ──
    {
      id: 'q10',
      sphere: 'savirealizacija',
      question: 'Kai pajuntu, kad gyvenime per daug rutinos ir per mažai gyvybės:',
      choices: {
        a: 'Sąmoningai įnešu naujų patirčių ir pokyčių, kurie grąžina man energiją.',
        b: 'Bėgu nuo savęs į pramogas, keliones ar pomėgius, bet tuštumos jausmas išlieka.',
        c: 'Po truputį įsileidžiu naujovių, kai tik jaučiuosi tam pasiruošęs.',
      },
    },
    {
      id: 'q11',
      sphere: 'savirealizacija',
      question: 'Kai galvoju apie savo gabumus ir gyvenimo kryptį:',
      choices: {
        a: 'Drąsiai išbandau įvairias sritis ir tikiu, kad mano įvairiapusiškumas yra dovana.',
        b: 'Niekur ilgai neužsibūnu, dažnai viską metu pusiaukelėje ir nuvertinu save.',
        c: 'Turiu kelias kryptis, bet stengiuosi jas plėtoti nuosekliai, viena po kitos.',
      },
    },
    {
      id: 'q12',
      sphere: 'savirealizacija',
      question: 'Kai gyvenimas pateikia sunkumų ar skausmingų pokyčių:',
      choices: {
        a: 'Greitai prisitaikau, randu naują kelią ir tikiu, kad pokytis veda į gera.',
        b: 'Bandau pabėgti nuo skausmo į nuolatinį veiksmą ar kitus užsiėmimus, kad tik nejausčiau.',
        c: 'Pergyvenu, bet pamažu prisitaikau prie naujų aplinkybių ir judu toliau.',
      },
    },
  ];

export default base5;
